export default "//static.glanacion.com/v2/ingresar-nuevo/images/error-not-found.png";